<template>
  <div class="_accountusers __wrapper_ py-4">
    <div class="row h-100 align-items-center">
      <div class="col-md-3 d-flex justify-content-center">
        <div class="_accountusers__left">
          <div class="row align-items-center d-flex justify-content-center _img__box">
            <img :src="image" style="width:80%; max-height: 140px;" v-if="image && !isLoading">
            <span v-else-if="isLoading"><b-spinner small variant="secondary" label="Spinning" /></span>
            <img class="__noAvatar" src="@/assets/image/avatar@3x.png" style="width:50%;" v-else-if="!image && !isLoading">
          </div>
          <div class="__updateMsg text-center">{{uploaded_msg}} </div>
          <div class="__errorMsg text-center">{{upload_error}}</div>
          <div class="_img__uploadbox justify-content-start mt-4">
            <p class="_img__uploadbox--textpp mb-2">Upload Profile Picture</p>
            <form>
              <div class="row m-0 __uploadbox--choose">
                <input type="file" name="myfile" id="fileUploadProfilePicture"
                ref="fileDocument"  @change="handleFileUpload" accept="image/jpeg, image/png, image/gif, image/jpg">
                <p>{{filename}}</p>
              </div>
              <p class="_img__uploadbox--textmax pb-3">*Maximum 5 MB</p>
              <button type="button" @click="uploadPhoto()" class="text-center _global__button--corporite">Upload</button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-9 pb-5">
        <div class="_accountusers__right">
          <div class="_top__box" v-if="account && company">
            <form @submit.prevent="updateAccount()">
            <div class="row">
              <div class="col-md-4">
                <b-form-group
                  id="input-group-1"
                  label="PIC Full Name"
                  label-for="input-1"
                  name="name">
                  <b-form-input
                    v-model="formAccount.name"
                    v-validate="'required'"
                    type="text"
                    name="name"
                    placeholder="Type your full name"
                  ></b-form-input>
                  <div class="__errorMsg"> {{errors.first('name') ? errors.first('name') : ''}} </div>
                </b-form-group>
                <b-form-group
                  label="Company Name"
                  id="input-group-1"
                  label-for="input-1"
                  name="companyName">
                  <b-form-input
                    v-model="formAccount.compname"
                    disabled
                    type="text"
                    name="company name"
                    v-validate="'required'"
                    placeholder="Type your company name"
                  ></b-form-input>
                  <div class="__errorMsg"> {{errors.first('company name')}} </div>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Position in Company"
                  label-for="input-1"
                  name="position">
                  <b-form-input
                    v-model="formAccount.position"
                    type="text"
                    placeholder="job position"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Phone Number"
                  label-for="input-1"
                  name="phone">
                  <div class="_accountusers__right--phone d-flex flex-row">
                  <div class="_customdropdown__input">
                    <b-input-group>
                      <b-dropdown right>
                        <template slot="button-content">
                          <p>{{ codeValue }}</p>
                        </template>
                        <b-dropdown-item v-on:click="selectedOption(option.text)" v-for="option in optionPhone" :key="option.id">
                          <span>{{ option.text }}</span>
                        </b-dropdown-item>
                        <template slot="button-content">
                          <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
                        </template>
                      </b-dropdown>
                    </b-input-group>
                  </div>
                  <div class="__phoneNumber d-flex align-items-center pr-1">
                    <b-form-input
                    v-model="formAccount.phone"
                    v-validate="'required'"
                    type="number"
                    name='phone number'
                    placeholder=""
                    class="__inputNumber"
                  ></b-form-input>
                  </div>
                </div>
                </b-form-group>

                <div :class="isValidPhone ? 'valid_phone' : '__errorMsg'">
                  *Please input your whatssap number without “0” in the first number e.g: 8123456789)
                </div>
              </div>
              <div class="col-md-4">
                <b-form-group
                  id="input-group-1"
                  class="_accountusers__right--email"
                  label="Email Address"
                  label-for="input-1" >
                  <b-form-input
                    v-model="formAccount.email"
                    v-validate="'required|email'"
                    type="email"
                    name="accountEmail"
                    data-vv-as="email"
                    placeholder=""
                  ></b-form-input>
                  <div class="__errorMsg"> {{errors.first('accountEmail')}} </div>
                </b-form-group>
                <div class="_accountusers__right--compaddress">
                  <b-form-group
                    id="input-group-1"
                    label="Company Address"
                    label-for="input-1"
                    name="company address">
                    <b-form-textarea
                      v-model="formAccount.address"
                      type="text"
                      name='company address'
                      v-validate="'required'">
                    </b-form-textarea>
                    <div class="__errorMsg"> {{errors.first('company address') ? errors.first('company address') : ''}} </div>
                  </b-form-group>
                </div>
                <b-form-group
                  label="NPWP Number"
                  id="input-group-1"
                  label-for="input-1"
                  name="NPWP">
                  <b-form-input
                    v-model="formAccount.npwp"
                    type="text"
                    placeholder="Ex: 80.552724.6-015.000"
                    >
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                 <b-form-group
                    id="input-group-1"
                    label="Salesname"
                    label-for="input-1" >
                    <b-form-input
                      v-model="account.salesname"
                      type="text"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                <div class="_accountusers__right--term">
                  <b-form-group
                    id="input-group-1"
                    label="Gender"
                    label-for="input-1" >
                    <div class="_customdropdown__input">
                      <b-input-group>
                        <b-dropdown right>
                          <template slot="button-content">
                            <p>{{ formAccount.gender }}</p>
                          </template>
                          <b-dropdown-item v-for="item in genderOptions" :key="item.id">
                            <span @click="changeGender(item.text)"> {{item.text}} </span>
                          </b-dropdown-item>
                          <template slot="button-content">
                            <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
                          </template>
                        </b-dropdown>
                      </b-input-group>
                    </div>
                  </b-form-group>
                </div>
                <b-form-group
                  id="input-group-1"
                  label="Term of Payment"
                  label-for="input-1" >
                  <b-form-input
                    v-model="formAccount.termofpayment"
                    type="text"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                 id="input-group-1"
                 label-for="input-1"
                 label="Industry Type">
                  <b-form-input
                    v-model="company.industry_type"
                    type="text"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <div class="_accountusers__right--term">
                  <b-form-group
                    id="input-group-1"
                    label="Yearly Revenue"
                    label-for="input-1" >
                    <div class="_customdropdown__input">
                      <b-input-group>
                        <b-dropdown right>
                          <template slot="button-content">
                            <p>{{ formAccount.yearlyRevenue }}</p>
                          </template>
                          <div class="_customdropdown__input" style="width: 180px;">
                            <b-dropdown-item v-for="item in yearlyRevenueOptions" :key="item.id">
                              <span @click="changeYearlyRevenue(item.text)"> {{item.text}} </span>
                            </b-dropdown-item>
                          </div>
                          <template slot="button-content">
                            <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
                          </template>
                        </b-dropdown>
                      </b-input-group>
                    </div>
                  </b-form-group>
                </div>
                <div class="row m-0 mt-5 text-right justify-content-end">
                  <button type="submit" class="text-center button__bluesmall px-3 py-2">Save</button>
                </div>
                <div :class="isUpdatedAcc ? '__updateMsg text-center mt-2': '__errorMsg text-center mt-2'">
                  <p>{{acc_alert_msg}}</p>
                </div>
              </div>
            </div>
            </form>
          </div>
          <div class="_bottom__box">
            <ValidationObserver ref="observerpwd">
            <form slot-scope="{ validate }"
                  @submit.prevent="validate().then(changePassword)">
              <div class="row">
                <div class="col-md">
                  <ValidationProvider name="new password" rules="required|verify_password">
                  <b-form-group
                    class="mb-1"
                    slot-scope="{ errors }"
                    label="Reset Password">
                    <b-form-input
                      v-model="formPassword.resetpwd"
                      v-bind:type="publicFieldType1"
                      placeholder="Enter Your New Password"
                    ></b-form-input>
                    <div class = "toggle-password" @click="publicToggleType('NEW_PWD')">
                      <img class="passwordvalue__eyesabsolute" src="@/assets/image/eye_slash@2x.png" v-if="publicFieldType1=='password'">
                      <img class="passwordvalue__eyesabsolute open" src="@/assets/image/eye@2x.png" v-if="publicFieldType1=='text'">
                    </div>
                    <div v-if="errors && errors.length && !isUpdatedPass && formPassword.resetpwd" class="fontstyle__errormsg">
                      {{ errors[0] }}
                    </div>
                    <div v-else-if="!formPassword.resetpwd" style="font-size: 12px">
                        Use 8 or more characters with a mix of small and capital letters, and numbers.
                    </div>
                  </b-form-group>
                  </ValidationProvider>
                </div>
                <div class="col-md">
                  <ValidationProvider name="password confirmation" rules="required" v-slot="{ errors }">
                  <b-form-group
                    class="mb-1"
                    label="Password Confirmation">
                    <b-form-input
                      v-model="formPassword.confpwd"
                      v-bind:type="publicFieldType2"
                      placeholder="Enter Password Confirmation"
                    ></b-form-input>
                    <div class = "toggle-password" @click="publicToggleType('CONFIRM_PWD')">
                      <img class="passwordvalue__eyesabsolute" src="@/assets/image/eye_slash@2x.png" v-if="publicFieldType2=='password'">
                      <img class="passwordvalue__eyesabsolute open" src="@/assets/image/eye@2x.png" v-if="publicFieldType2=='text'">
                    </div>
                  </b-form-group>
                  <div v-if="errors && errors.length && !isUpdatedPass && formPassword.confpwd" class="fontstyle__errormsg">
                    {{ errors[0] }}
                  </div>
                  <div v-else-if="formPassword.confpwd && formPassword.resetpwd !== formPassword.confpwd"
                    class="text-left fontstyle__errormsg">
                    Passwords do not match.
                  </div>
                  </ValidationProvider>
                </div>
                <div class="col-md-2 pt-2">
                  <button type="submit" class="text-center button__bluesmall px-3 py-2 mt-4">Save</button>
                </div>
              </div>
              <div class="__updateMsg text-right pr-1" style="font-size: 12px" v-if="pass_alert_msg">
                <p> {{ pass_alert_msg }} </p>
              </div>
            </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'
import mixin from '@/mixin'
import ConfigPassword from '@/mixin/getters/config-password'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: '',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      image: '',
      pass_alert_msg: '',
      acc_alert_msg: '',
      upload_error: '',
      uploaded_msg: '',
      isUpdatedPass: false,
      isUpdatedAcc: false,
      codeValue: '+62',
      isValidPhone: true,
      filename: 'Choose File',
      formAccount: {
        name: '',
        position: '',
        gender: '',
        email: '',
        phone: '',
        address: '',
        termofpayment: '',
        npwp: '',
        compname: '',
        yearlyRevenue: ''
      },
      formPassword: {
        resetpwd: '',
        confpwd: ''
      },
      optionPhone: [
        { id: 1, text: '+62', value: '' },
        { id: 2, text: '+91', value: '' },
        { id: 3, text: '+86', value: '' }
      ],
      submitted: false,
      genderOptions: [
        {text: 'Male', value: 'M'},
        {text: 'Female', value: 'F'}
      ],
      yearlyRevenueOptions: [
        {id: 1, text: '<= IDR 50.000.000.000'},
        {id: 2, text: '> IDR 50.000.000.000'}
      ]
    }
  },
  mixins: [mixin, ConfigPassword],
  computed: {
    ...mapGetters({
      // fetch account
      account: 'settingAccount/account',
      error: 'settingAccount/error',
      isLoading: 'settingAccount/isLoading',

      updateChangePassword: 'settingAccount/changePassword',
      isLoadingChangePassword: 'settingAccount/isLoadingChangePassword',
      errorChangePassword: 'settingAccount/errorChangePassword',
      // fetch company
      company: 'settingCompany/company',
      companyError: 'settingCompany/error',
      companyIsLoading: 'settingCompany/isLoading',
      // update account
      updated: 'settingAccount/updateAccount',
      errorUpdateAccount: 'settingAccount/errorUpdateAccount',
      isLoadingUpdateAccount: 'settingAccount/isLoadingUpdateAccount'
    })
  },
  mounted () {
    this.fetchAccount()
    this.fetchCompanyProfile()
  },
  methods: {
    removeZeroFirstChar (phoneString) {
      let str = phoneString ? phoneString.toString() : null
      if (phoneString) {
        if (str.charAt(0) === '+') {
          str = str.substring(3) // remove first character
        }

        if (str.charAt(0) === '0') {
          str = str.substring(1) // remove first character
        } else if (str.charAt(0) === '6' && str.charAt(1) === '2') {
          str = str.substring(2)
        }
      }
      return `${str}`
    },
    handleFileUpload () {
      this.image = this.$refs.fileDocument.files[0]
      this.filename = this.$refs.fileDocument.files[0].name
      this.upload_error = ''
      this.uploaded_msg = ''
      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.image = reader.result
      }.bind(this), false)
      if (this.image) {
        if (/\.(jpe?g|png|gif)$/i.test(this.image.name)) {
          reader.readAsDataURL(this.image)
        }
      }
    },
    async uploadPhoto () {
      let formData = new FormData()
      formData.append('fileImage', this.$refs.fileDocument.files[0])
      this.submitted = true
      if (this.$refs.fileDocument.files[0].size > 5000000) {
        this.upload_error = 'Your file exceeded maximum requirement file'
      } else {
        await this.$store.dispatch('settingAccount/UPLOAD_PHOTO', formData)
        this.upload_error = ''
        this.fetchAccount()
        setTimeout(() => {
          this.uploaded_msg = this.account.photo ? 'Profile picture has been succesfully uploaded' : ''
        }, 1000)
      }
    },
    selectedOption: function (event) {
      this.codeValue = event
    },
    fetchAccount () {
      this.$store.dispatch('settingAccount/FETCH_ACCOUNT')
    },
    fetchCompanyProfile () {
      this.$store.dispatch('settingCompany/FETCH_COMPANY')
    },
    updateAccount (e) {
      this.$validator.validateAll().then(async (result) => {
        if (result && this.isValidPhone) {
          const payload = {
            fullname: this.formAccount.name,
            job: this.formAccount.position,
            gender: this.formAccount.gender.charAt(0),
            email: this.formAccount.email,
            phone: `+62${this.removeZeroFirstChar(this.formAccount.phone)}`,
            companyAddress: this.formAccount.address,
            npwp: this.formAccount.npwp,
            termofpayment: parseInt(this.formAccount.termofpayment.split(' ').shift()),
            photo: this.account.photo,
            compname: this.formAccount.compname,
            yearlyRevenue: this.formAccount.yearlyRevenue
          }
          this.submitted = true
          await this.$store.dispatch('settingAccount/UPDATE_ACCOUNT', payload).then(() => {
            this.fetchAccount()
            if (this.errorUpdateAccount) {
              this.accountUpdated('Sorry, account cannot updated!', false)
            } else {
              this.accountUpdated('Successfully updated!', true)
            }
          })
        }
      })
    },
    clearText (text, type) {
      this.pass_alert_msg = text
      this.isUpdatedPass = type
      this.resetFormPwd()
    },
    accountUpdated (text, type) {
      this.acc_alert_msg = text
      this.isUpdatedAcc = type
      setTimeout(() => (this.acc_alert_msg = ''), 4000)
    },
    resetFormPwd () {
      this.formPassword.resetpwd = ''
      this.formPassword.confpwd = ''
      setTimeout(() => (this.pass_alert_msg = ''), 4000)
      this.isUpdatedPass = false
      this.$validator.reset()
    },
    async changePassword () {
      this.error_msg = ''
      if (this.formPassword.resetpwd === this.formPassword.confpwd) {
        const payload = {
          userPassword: this.formPassword.resetpwd,
          userPasswordConfirm: this.formPassword.confpwd
        }
        this.submitted = true
        await this.$store.dispatch('settingAccount/CHANGE_PASSWORD', payload)
        this.fetchAccount()
      }
    },
    changeGender (text) {
      this.formAccount.gender = text
    },
    changeYearlyRevenue (text) {
      this.formAccount.yearlyRevenue = text
    }
  },
  watch: {
    account (data) {
      this.formAccount.name = data.fullname
      this.formAccount.position = data.job
      this.formAccount.email = data.email
      this.formAccount.gender = data.gender === 'F' ? 'Female' : 'Male'
      this.formAccount.phone = this.removeZeroFirstChar(data.phone)
      this.image = data.photo ? this.getImageAWS(data.photo) : ''
      this.formAccount.address = data.companyAddress
      this.formAccount.npwp = data.npwp
      this.formAccount.compname = data.compname
      this.formAccount.yearlyRevenue = data.yearlyRevenue
      if (data.npwp !== 'Cash' || 'CASH' || 'cash') {
        this.formAccount.termofpayment = data.termofpayment + ' Days'
      } else {
        this.formAccount.termofpayment = data.termofpayment
      }
    },
    updateChangePassword (data) {
      if (data) {
        this.clearText(data.message, true)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/MyAccount.vue